import { DataService } from '../services/data_service';
import { ContentDetail } from '../entry-components/content-details/content-details.model';
import { EntryComponentConfig } from '../shared/types/common.model';

export class ContentDetailsClient {
  private dataService: DataService;

  constructor(internalConfig: EntryComponentConfig) {
    this.dataService = DataService.getInstance(internalConfig.baseUrl);
  }

  async getContentDetails(contentType: string, contentId: string, signal?: AbortSignal): Promise<ContentDetail> {
    const path = `/angie/content-details/item/${contentId}.json?content_type=${contentType}`;

    let response = await this.dataService.get(path, signal);
    response = Array.isArray(response) ? response[0] : response;
    return (response as { data: ContentDetail }).data;
  }

  /**
   * Fetch session details for a specific training_id and course_id from the monolith route.
   * @param trainingId The training ID to fetch sessions for
   * @param courseId The course ID to fetch sessions for
   */
  async getTrainingSessions(trainingId: string, courseId: string): Promise<any> {
    const params = new URLSearchParams({
      training_id: trainingId,
      course_id: courseId,
    });

    const path = `/angie/content-details/training_sessions?${params.toString()}`;
    return await this.dataService.get(path);
  }
  /**
   * Fetch course data for a course that may not have a Spree product (bundle course).
   */
  async fetchCourseDataNoProduct(courseId: string, signal?: AbortSignal): Promise<ContentDetail> {
    const path = `/angie/content-details/fetch_course_data/${courseId}`;
    let response = await this.dataService.get(path, signal);
    response = Array.isArray(response) ? response[0] : response;
    return (response as { data: ContentDetail }).data;
  }

  /**
   * Fetch training sessions for a course that may not have a Spree product (bundle course).
   * @param courseId The course ID to fetch sessions for
   * @param trainingId Optional training ID to filter sessions
   * @param signal Optional AbortSignal
   */
  async fetchTrainingSessionsNoProduct(courseId: string, trainingId?: string, signal?: AbortSignal): Promise<any> {
    let path = `/angie/content-details/fetch_training_sessions_data/${courseId}`;
    if (trainingId) {
      path += `?training_id=${encodeURIComponent(trainingId)}`;
    }
    return await this.dataService.get(path, signal);
  }
}
